/**
 * Logger utility for API services
 * Only logs in development mode to avoid console pollution in production
 */

const isDevelopment = import.meta.env.DEV

/**
 * Log debug information (only in development)
 */
export function logDebug(message: string, ...args: unknown[]): void {
  if (isDevelopment) {
    console.log(`[API Debug] ${message}`, ...args)
  }
}

/**
 * Log warnings (always)
 */
export function logWarning(message: string, ...args: unknown[]): void {
  console.warn(`[API Warning] ${message}`, ...args)
}

/**
 * Log errors (always)
 */
export function logError(message: string, ...args: unknown[]): void {
  console.error(`[API Error] ${message}`, ...args)
}

